<template>
  <div class="cookie" v-if="cookie != 1">
    <div class="text">{{$t('PublicComponents.Cookie.Cookie')}}</div>
    <div class="accept_box">
      <div class="accept" @click="setCookies(1)">{{$t('PublicComponents.Cookie.Accept')}}</div>
      <div class="accept" @click="setCookies(1)">{{$t('PublicComponents.Cookie.AcceptOnly')}}</div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    return {
      cookie: "",
      scroll: "",
      opacity: 1,
      canRun: true
    };
  },
  mounted() {
    this.cookie = window.localStorage.getItem("cookie");
    if (this.cookie != 1) {
      // window.addEventListener("scroll", this.handleScrolls);
    }
      var cookieScrollTopHeight = document.querySelector(".cookie");
    // if (this.terminal != "pc") {
    
    //   cookieScrollTopHeight.style.background = `rgba(3, 14, 37, 1)`;
    // }else{
    //     cookieScrollTopHeight.style.background = `rgba(3, 14, 37, .4)`;
    // }
    cookieScrollTopHeight.style.background = `rgba(61,63,77, 1)`;
  },
  methods: {
    setCookies(val) {
      this.cookie = 1;
      window.localStorage.setItem("cookie", val);
    },
    handleScrolls() {

      if (!this.canRun) {
        // 判断是否已空闲，如果在执行中，则直接return
        return;
      }
      console.log(this.terminal)
      // if (this.terminal != "pc") {
      //   var cookieScrollTopHeight = document.querySelector(".cookie");
      //   cookieScrollTopHeight.style.background = `rgba(3, 14, 37, 1)`;
      //   return;
      // }
      //         console.log(1)
      this.canRun = false;
    
      setTimeout(() => {
        this.scroll =
          document.documentElement && document.documentElement.scrollTop;
        var cookieScrollTopHeight = document.querySelector(".cookie");
        var clientHeight = document.documentElement.clientHeight;
        this.opacity = (window.pageYOffset * 1.6) / clientHeight;

          if (this.opacity <= 0.1) {
          this.opacity = 0.1;
        }
        if (this.opacity >= 0.95) {
          this.opacity = 1;
        }
        cookieScrollTopHeight.style.background = `rgba(61,63,77, ${this.opacity})`;

        this.canRun = true;
      }, 0);
    }
  },
  beforeDestroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.handleScrolls);
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>
.cookie {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  // height: 120px;
  border-top: 6px solid rgba(51, 94, 111, 0.3);
  //   background: rgba(3, 14, 37, 0.3);
  .text {
    color: #fff;
    width: 80%;
    font-size: 16px;
    text-align: center;
    margin: 20px auto;
    word-break: break-word;
  }
  .accept_box {
    display: flex;
    justify-content: center;
    // width: 50%;
    margin-bottom: 20px;

    .accept {
      color: #fff;
      font-size: 16px;
      padding: 10px 20px;
      background: rgba(255, 255, 255, 0.1);
      cursor: pointer;
      margin-right: 10px;
      transition: 0.1s;
    }
    .accept:hover {
      transition: 0.1s;
      background: rgba(255, 255, 255, 0.4);
    }
  }
}
</style>